const userAgentBrowserBlacklist = {
  opera: 'OPR',
  edgeMac: 'Edg'
}

export default {
  isChromiumBased: () => typeof navigator !== 'undefined' && navigator.vendor === 'Google Inc.',
  isChrome: () => typeof navigator !== 'undefined' && navigator.vendor === 'Google Inc.' &&
    !Object.values(userAgentBrowserBlacklist).find((uaStr) => navigator.userAgent.indexOf(uaStr) !== -1),
  isEdge:()=>  typeof navigator !== 'undefined' && navigator.vendor === 'Google Inc.' && navigator.userAgent.indexOf('Edg') >= 0 ,
  isSafariVersionBelow14: () => typeof navigator !== 'undefined' &&
    navigator.vendor.toLowerCase() === 'apple computer, inc.' &&
    !!navigator.appVersion &&
    navigator.appVersion.match(/version\/(\d+)/i) != null &&
    parseInt((navigator.appVersion!.match(/version\/(\d+)/i)||[,'15'])[1]||'15') < 14 ,
  isSafari: () => typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

}
